<template>
    <div>
        <div>
            <div class="modal alert-modal" :class="{ 'show d-block': show || (!this.$root.activable) }" tabindex="-1"
                role="dialog" id="modal3" aria-labelledby="modal3Title">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <svg class="icon">
                                <use href="/bootstrap-italia/dist/svg/sprites.svg#it-info-circle"></use>
                            </svg>
                            <h2 class="modal-title h5" id="modal3Title">Gestisci il tuo profilo</h2>
                            <button v-if="this.$root.user.activable" type="button" class="btn-close"
                                @click="closeModal"></button>
                        </div>
                        <div class="modal-body">
                            <div v-if="!this.$root.user.activable && !this.$root.user.active && this.$root.accessMessages.registration_creation_message && this.$root.accessMessages.registration_creation_message.replace(/<\/?[^>]+(>|$)/g, '') != ''"
                                class="alert alert-info" role="alert">
                                <div v-html="sanitize(this.$root.accessMessages.registration_creation_message)"></div>
                            </div>

                            <div v-if="showMessage"
                                :class="['alert', messageType === 'success' ? 'alert-success' : 'alert-danger']"
                                role="alert">
                                {{ message }}
                            </div>

                            <form class="mt-5" @submit.prevent="sendUseRequest">
                                <div class="form-group">
                                    <label for="email" class="form-label active">Email:</label>
                                    <input :disabled="this.$root.user.active" type="email" required class="form-control"
                                        id="email" v-model="this.$root.user.email" placeholder="Inserisci l'email">
                                </div>
                                <div class="form-group">
                                    <label for="tenant_name" class="form-label active">Denominazione Ente:</label>
                                    <input :disabled="this.$root.user.active" type="text" required class="form-control"
                                        id="tenant_name" v-model="this.$root.user.tenant_name"
                                        placeholder="Inserisci la Denominazione Ente">
                                </div>
                                <div class="form-group">
                                    <label for="ausa_code" class="form-label active">Codice AUSA Ente:</label>
                                    <input :disabled="this.$root.user.active" type="text" required class="form-control"
                                        id="ausa_code" v-model="this.$root.user.ausa_code"
                                        placeholder="Inserisci il codice AUSA" maxlength="10">
                                </div>
                                <div class="form-group">
                                    <label for="tenant_fiscal_code" class="form-label active">Codice Fiscale
                                        Ente:</label>
                                    <input :disabled="this.$root.user.active" type="text" required class="form-control"
                                        id="tenant_fiscal_code" v-model="this.$root.user.tenant_fiscal_code"
                                        placeholder="Inserisci il codice Fiscale Ente" maxlength="11">
                                </div>
                                <button :disabled="this.$root.user.active || isSubmitting" type="submit"
                                    class="btn btn-primary btn-sm mb-4 w-100"> <span v-if="isSubmitting"
                                        class="spinner-border spinner-border-sm" role="status"
                                        aria-hidden="true"></span>
                                    <span>{{ isSubmitting ? 'Aggiornamento in corso...' : 'Aggiorna' }}</span></button>
                                <button type="button" class="btn btn-outline-secondary btn-sm mb-4 w-100"
                                    @click="$emit('switchBack')">
                                    <svg class="icon icon-sm me-2">
                                        <use
                                            :href="this.$root.baseURL + '/bootstrap-italia/dist/svg/sprites.svg#it-arrow-left'">
                                        </use>
                                    </svg>
                                    Indietro
                                </button>
                                <a v-if="!this.$root.user.activable" class="btn btn-danger btn-sm mb-4 w-100"
                                    role="button"
                                    :href="this.$root.config.VITE_APP_BACKOFFICE_URL + '/auth/sso/logout'">
                                    <svg class="icon icon-sm icon-white me-2">
                                        <use
                                            :href="this.$root.baseURL + '/bootstrap-italia/dist/svg/sprites.svg#it-logout'">
                                        </use>
                                    </svg>
                                    Logout
                                </a>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div v-if="show" class="modal-backdrop fade show"></div>
</template>

<script>
import { sanitize } from '../../utils/sanitize';

export default {
    name: 'UseRequest',
    props: {
        show: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            message: '',
            messageType: '', // 'success' o 'error'
            showMessage: false,
            isSubmitting: false
        }
    },
    methods: {
        sanitize(html) {
            return sanitize(html);
        },
        async downloadFile() {
            try {
                const response = await this.$root.$api.get('/downloadPdf', {
                    responseType: 'blob',
                });

                const blob = new Blob([response.data], { type: 'application/pdf' });
                const url = window.URL.createObjectURL(blob);

                const a = document.createElement('a');
                a.href = url;
                a.download = 'modelloautodichiarazione.pdf';
                document.body.appendChild(a);
                a.click();
                a.remove();

                window.URL.revokeObjectURL(url);
            } catch (err) {
                console.error('Errore nel download:', err);
                this.messageType = 'danger';
                this.message = 'Errore durante il download del documento.';
                this.showMessage = true;
            }
        },
        closeModal() {
            //localStorage.removeItem('token');
            localStorage.removeItem('showed_user_request_ipa')
            this.$emit('update:show', false);
            window.location.href = this.$root.config.VITE_APP_BACKOFFICE_URL + '/auth/sso/logout';
        },
        sendUseRequest() {
            this.isSubmitting = true;
            const token = localStorage.getItem('token');
            fetch(`${this.$root.config.VITE_APP_BACKOFFICE_URL}/auth/use-request`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token ? `Bearer ${token}` : ''
                },
                //credentials: 'include',
                body: JSON.stringify({
                    request_use: this.$root.user
                })
            })
                .then(response => {
                    // Salva lo stato della risposta HTTP
                    const isSuccess = response.ok;
                    return response.json().then(data => {
                        this.$root.user.activable = data.activable;
                        // Aggiungi lo stato HTTP ai dati della risposta
                        return { ...data, isSuccess, status: response.status };
                    });
                })
                .then(data => {
                    if (data.isSuccess) {
                        // Risposta di successo
                        this.messageType = 'success';
                        this.message = data.message || 'Richiesta di fruizione inviata con successo';
                        this.showMessage = true;

                        this.downloadFile();

                        // Chiudi la modal dopo 2 secondi
                        /**setTimeout(() => {
                            this.$emit('update:show', false);
                        }, 2000);*/
                    } else {
                        // Risposta di errore
                        this.messageType = 'error';
                        this.message = data.message || 'Si è verificato un errore';

                        // Se ci sono errori di validazione, mostra il primo errore
                        if (data.errors) {
                            const firstError = Object.values(data.errors)[0];
                            if (Array.isArray(firstError) && firstError.length > 0) {
                                this.message += ': ' + firstError[0];
                            }
                        }

                        this.showMessage = true;
                    }
                })
                .catch(error => {
                    console.error('Errore durante l\'invio della richiesta:', error);
                    this.messageType = 'error';
                    this.message = 'Si è verificato un errore di connessione. Riprova più tardi.';
                    this.showMessage = true;
                })
                .finally(() => {
                    this.isSubmitting = false;
                });
        }
    }
}
</script>

<style scoped>
@media(min-width: 576px) {
    .modal-dialog {
        margin-left: auto !important;
        margin-right: auto !important;
    }
}

@media(max-width: 576px) {
    .modal-dialog {
        margin: 0 !important;
        margin-top: auto !important;
        margin-bottom: auto !important;
    }
}

.alert h3,
.alert p {
    word-break: break-word;
}

.alert-modal .modal-dialog .modal-content .modal-body p {
    padding-left: 0 !important;
}

div.alert div p {
    margin-bottom: 0;
}

.alert>div>ul>li>p {
    padding-bottom: 0;
    margin-bottom: 0;
}

.modal-backdrop {
    z-index: 1040;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    /* sfondo scuro trasparente */
}

.modal {
    z-index: 1050;
    display: block;
}

/* Correzione stile input disabilitati come UserSection */
.form-control:disabled,
.form-control[readonly] {
    border-color: #ced4da;
    background-color: #f8f9fa;
}

select.form-select option {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
    display: block;
}

.spinner-border {
    width: 2rem;
    height: 2rem;
}
</style>